// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
const hardReplacementCodes = new Set([
  "empty_file",
  "invalid_pdf_signature",
  "pdf_encrypted",
  "pdf_malformed",
  "pdf_no_text",
  "multiple_employees",
  "ambiguous_payslip_split",
  "employee_identity_missing",
  "required_paid_hours_missing",
]);

export const payslipRequiresReplacement = (record: {
  requiresReplacement?: boolean;
  validationCodes?: string[];
}) =>
  record.requiresReplacement === true ||
  (record.validationCodes ?? []).some((code) => hardReplacementCodes.has(code));

const attentionMatchStatuses = new Set([
  "unmatched",
  "duplicate",
  "period_mismatch",
  "period_missing",
  "split_review",
  "failed",
]);

export const payslipNeedsAttention = (record: {
  parserStatus?: string;
  matchStatus?: string;
  usable?: boolean;
  requiresReplacement?: boolean;
  validationCodes?: string[];
}) =>
  payslipRequiresReplacement(record) ||
  record.parserStatus === "failed" ||
  record.usable === false ||
  attentionMatchStatuses.has(record.matchStatus ?? "");

export const payslipUploadResultMessage = (code: string, fallback: string) => {
  if (code === "duplicate_in_selection")
    return "Duplicate removed automatically. This exact PDF was selected more than once.";
  if (code === "duplicate_already_uploaded")
    return "Duplicate removed automatically. The identical PDF already exists for this payroll month.";
  if (code === "existing_payslip_kept")
    return "The existing payslip was kept. The repeated upload was removed from review.";
  if (code === "multiple_employees")
    return "Upload one separate PDF per employee.";
  if (code === "ambiguous_payslip_split")
    return "Payslip boundaries are ambiguous. Upload a replacement PDF with clearly separated payslips.";
  if (code === "pdf_no_text")
    return "This PDF does not contain extractable text. Upload the original text-based PDF.";
  if (code === "pdf_encrypted")
    return "Remove the PDF password, then upload it again.";
  if (code === "invalid_pdf_signature") return "Choose a real PDF file.";
  if (/before reconciliation/i.test(fallback))
    return "Payslip extracted. Confirm it before checking balances.";
  return fallback;
};
